import { all, put, call, spawn, takeLeading } from 'redux-saga/effects'
import dayjs from 'dayjs'

import { actions } from '..'
import { services } from '../../graphql'
import { getAuthCookie, removeAuthCookie, setAuthCookie } from '../../helpers/CookieHelpers'
import ApiSagas from '../api/sagas'
import { ApiResponse } from '../api/types/state'
import { AuthCheckTokenQueryVariables, AuthLoginMutationVariables } from '../../graphql/types/api'
// eslint-disable-next-line import/no-cycle
import AppSagas from '../app/sagas'
import * as configuration from '../../configuration'
import { Screen } from '../../types/global'

import { actionTypes } from './types'

export default class AuthSagas {
  static *onInit() {
    const cookie = getAuthCookie()
    if (cookie) {
      yield put(actions.auth.setImpersonate(cookie?.impersonate ?? false))
      // yield put(actions.auth.setToken({ token: cookie.token }))
    }
  }

  static *onLoginRequest({ payload }: ReturnType<typeof actions.auth.loginRequest>) {
    const response: ApiResponse<typeof services.auth.mutations.login> = yield call(
      ApiSagas.mutate,
      services.auth.mutations.login,
      {
        email: payload.email,
        password: payload.password,
      } as AuthLoginMutationVariables
    )

    if (response.errors) {
      yield put(actions.auth.loginError(response.errors))
    }

    if (response.data) {
      yield put(
        actions.auth.setToken({
          token: response.data.token!,
          expireAt: dayjs().add(configuration.cookie.DURATION, 'days').toString(),
          setCookies: true,
        })
      )

      yield spawn(AppSagas.loadAuthData)

      yield put(actions.auth.loginSuccess(null))
      yield put(actions.app.setScreen({ screen: Screen.appointement }))
    }
  }

  static onSetToken({ payload }: actionTypes.setToken) {
    if (payload.setCookies) {
      setAuthCookie(
        { token: payload.token },
        { expires: payload.expireAt ? new Date(payload.expireAt) : undefined }
      )
    }
  }

  static *onForgotPasswordRequest({
    payload,
  }: ReturnType<typeof actions.auth.forgetPasswordRequest>) {
    const response: ApiResponse<typeof services.auth.mutations.forgotPassword> = yield call(
      ApiSagas.mutate,
      services.auth.mutations.forgotPassword,
      payload
    )

    if (response.errors) {
      yield put(actions.auth.forgetPasswordError(response.errors))
    }

    if (response.data) {
      yield put(actions.auth.forgetPasswordSuccess(null))
    }
  }

  static *onResetPasswordRequest({
    payload,
  }: ReturnType<typeof actions.auth.resetPasswordRequest>) {
    const response: ApiResponse<typeof services.auth.mutations.resetPassword> = yield call(
      ApiSagas.mutate,
      services.auth.mutations.resetPassword,
      payload
    )

    if (response.errors) {
      yield put(actions.auth.resetPasswordError(response.errors))
    }

    if (response.data) {
      yield put(actions.auth.resetPasswordSuccess(null))
    }
  }

  static *onGetMeRequest() {
    const response: ApiResponse<typeof services.auth.queries.getMe> = yield call(
      ApiSagas.query,
      services.auth.queries.getMe
    )

    console.log(response)

    if (response.errors) {
      yield put(actions.auth.getMeError(response.errors))
    }

    if (response.data) {
      yield put(actions.auth.getMeSuccess(response.data))
    }
  }

  static *onCheckTokenRequest({ payload }: ReturnType<typeof actions.auth.checkTokenRequest>) {
    const response: ApiResponse<typeof services.auth.queries.checkToken> = yield call(
      ApiSagas.query,
      services.auth.queries.checkToken,
      {
        ...payload,
      } as AuthCheckTokenQueryVariables
    )

    if (response.errors) {
      yield put(actions.auth.checkTokenError(response.errors))
    } else {
      yield put(actions.auth.checkTokenSuccess(response.data))
    }
  }

  static onResetAuth() {
    removeAuthCookie()
  }

  static *loop() {
    yield all([
      takeLeading(actions.auth.loginRequest, this.onLoginRequest),
      takeLeading(actions.auth.setToken, this.onSetToken),
      takeLeading(actions.auth.resetAuth, this.onResetAuth),
      takeLeading(actions.auth.forgetPasswordRequest, this.onForgotPasswordRequest),
      takeLeading(actions.auth.resetPasswordRequest, this.onResetPasswordRequest),
      takeLeading(actions.auth.getMeRequest, this.onGetMeRequest),
      takeLeading(actions.auth.checkTokenRequest, this.onCheckTokenRequest),
    ])
  }
}
